import StudentLessonProgress from './StudentLessonProgress';

export default StudentLessonProgress;
